import styled from 'styled-components';

export const Wrapper = styled.button`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  align-items: center;
  border: 0px;
  cursor: pointer;
  width: 100%;
  max-width: 85px;
  background: none;
`;
